export default __webpack_public_path__ + "static/media/T1_350x500.251d0505.png";